type IntegrationLogoProps = {
  initials: string;
};

/**
 * Monograma do sistema. Placeholder até os logos oficiais entrarem em
 * public/: o nome do sistema já está no título do card, então é decorativo.
 */
export const IntegrationLogo = ({ initials }: IntegrationLogoProps) => (
  <span
    aria-hidden="true"
    className="rounded-ds-md border-ds-border bg-ds-surface-sunken font-ds-sans text-ds-small text-ds-ink-700 flex size-12 shrink-0 items-center justify-center border font-semibold"
  >
    {initials}
  </span>
);
